import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentAttemptsListItemCtrl implements IController {

  attempt: any;
  attemptNumber: number;
  step: any;

  private service: any;
  private isAttemptOpen: any;

  /* @ngInject */
  constructor(private $delivery: any) {}

  $onInit() {
  }

  $onChanges(changes) {
    if (changes.attempt && !changes.attempt.isFirstChange()) {
      this.onToggleAttempt();
    }
  }

  onToggleAttempt() {
    this.isAttemptOpen = !this.isAttemptOpen;

    if (this.isAttemptOpen) {
      this._getServiceInfo(this.attempt.referenceId);
    } else {
      this.service = undefined;
    }
  }

  private _getServiceInfo(serviceId) {
    this.$delivery(serviceId).$asyncValue()
      .then((service) => {
        this.service = service;
      })
  }

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentAttemptsListItem', {
    bindings: {
      attempt: '<',
      attemptNumber: '<',
      step: '<',
      service: '<'
    },
    template: require('./fulfillment-attempts-list-item.html').default,
    controller: fulfillmentAttemptsListItemCtrl
  });
